import { useCallback } from "react"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { Country } from "@/modules/patients/services/__generated__/PatientFragment.graphql"
import {
  Ch_createOrUpdatePatientBodyMeasurementInput,
  chCreateOrUpdatePatientBodyMeasurementMutation,
  chCreateOrUpdatePatientBodyMeasurementMutation$data,
} from "@/modules/patients/services/ch/__generated__/chCreateOrUpdatePatientBodyMeasurementMutation.graphql"
import { chCreateOrUpdatePatientBodyMeasurementMutation as chMutation } from "@/modules/patients/services/ch/chCreateOrUpdatePatientBodyMeasurementMutation"
import {
  De_createOrUpdatePatientBodyMeasurementInput,
  deCreateOrUpdatePatientBodyMeasurementMutation,
  deCreateOrUpdatePatientBodyMeasurementMutation$data,
} from "@/modules/patients/services/de/__generated__/deCreateOrUpdatePatientBodyMeasurementMutation.graphql"
import { deCreateOrUpdatePatientBodyMeasurementMutation as deMutation } from "@/modules/patients/services/de/deCreateOrUpdatePatientBodyMeasurementMutation"

export const useCreateOrUpdatePatientBodyMeasurementMutation = (country: Country) => {
  const mutation = (() => {
    switch (country) {
      case "CH":
        return chMutation
      case "DE":
        return deMutation
    }
  })()
  const [commit] = useMutationWithErrorDialog<
    deCreateOrUpdatePatientBodyMeasurementMutation & chCreateOrUpdatePatientBodyMeasurementMutation
  >(mutation)

  return useCallback(
    (
      input: De_createOrUpdatePatientBodyMeasurementInput & Ch_createOrUpdatePatientBodyMeasurementInput,
      connectionID: string,
      onCompleted?: (
        res: deCreateOrUpdatePatientBodyMeasurementMutation$data & chCreateOrUpdatePatientBodyMeasurementMutation$data,
      ) => void,
      onError?: (
        res: deCreateOrUpdatePatientBodyMeasurementMutation$data & chCreateOrUpdatePatientBodyMeasurementMutation$data,
      ) => void,
    ) => {
      commit({
        variables: {
          input,
          connections: [connectionID],
        },
        onCompleted(response) {
          const data = response.createOrUpdatePatientBodyMeasurement

          if (!data.errors?.length) {
            onCompleted?.(response)
          } else {
            onError?.(response)
          }
        },
      })
    },
    [commit],
  )
}
